import { IKnnDistance, IKnnParameters, IKnnResult } from '../knn-interfaces';
import { DistanceType } from '../../../cluster/cluster-interfaces';
import {
    euclideanDistance,
    euclideanDistanceExplanation,
    manhattanDistance,
    manhattanDistanceExplanation
} from '../../../cluster/cluster-provider';

const calculateDistance = (params: IKnnParameters, distance: DistanceType): IKnnDistance[] => {

    const distances: IKnnDistance[] = [];

    for(let i=0; i<params.rows.length; i++) {

        const row = params.rows[i];

        let d = 0;
        let calc = '';

        switch (distance) {
            case DistanceType.Manhattan: {
                d = manhattanDistance(row, params.question);
                calc = manhattanDistanceExplanation(row, params.question);
                break;
            }

            case DistanceType.Euclidean: {
                d = euclideanDistance(row, params.question);
                calc = euclideanDistanceExplanation(row, params.question);
                break;
            }
        }

        distances.push({
            calculations: calc,
            value: d,
            rowIndex: i,
            isInKRange: false,
        });
    }

    distances.sort((a, b) => a.value - b.value);

    for(let i=0; i<params.k; i++) {
        distances[i].isInKRange = true;
    }

    return distances;
};

const getTargetValuesMap = (params: IKnnParameters, distances: IKnnDistance[]) => {
    const targetValuesMap = new Map<string, number>();
    for(const distance of distances) {
        if(!distance.isInKRange) continue;

        const targetValue = params.targetValues[distance.rowIndex];
        const count = targetValuesMap.get(targetValue) ?? 0;
        targetValuesMap.set(targetValue, count + 1);
    }

    return targetValuesMap;
};

export const calculateKnnClassifier = (params: IKnnParameters, distance: DistanceType) : IKnnResult => {

    const result: IKnnResult = {
        distances: [],
        targetResults: [],
        maxProperty: '',
    };

    result.distances = calculateDistance(params, distance);

    const targetValuesMap = getTargetValuesMap(params, result.distances);
    result.targetResults = [...targetValuesMap];

    let maxCount = 0;
    for(const [prop, count] of result.targetResults) {
        if(count > maxCount) {
            maxCount = count;
            result.maxProperty = prop;
        }
    }

    return result;
};